// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3dFDH","errorLogs":"EditorFooter_errorLogs__2MiYM"};